import {useContext} from 'react';
import {
  PopoutWindowContext,
  type PopoutWindowContextValue,
} from '../PopoutWindowContext';

// ----------------------------
// usePopoutWindow
// ----------------------------
export const usePopoutWindow = (): PopoutWindowContextValue => {
  return useContext(PopoutWindowContext);
};

export default usePopoutWindow;
